export default "assets/images/f418c69078837bcf2c5e707a6b7f8244.png";